export var CustomerCategory;
(function (CustomerCategory) {
  CustomerCategory["Consultant"] = "Consultant";
  CustomerCategory["EndConsumer"] = "EndConsumer";
  CustomerCategory["EndCustomer"] = "EndCustomer";
  CustomerCategory["Employee"] = "Employee";
  CustomerCategory["Anonymous"] = "Anonymous";
  CustomerCategory["Other"] = "Other";
  CustomerCategory["Invitation"] = "Invitation";
})(CustomerCategory || (CustomerCategory = {}));